import { setDocumentId, setSaving, removeImageManifestEntries, AppDispatch, RootState } from "utils/store";
import { postTemplate } from "utils/api";
import { deletePhoto } from "./deletePhoto";
import { findOrphanedManifestEntries } from "utils/templates/image-manifest";
import { environment } from "environments/environment";

/**
 * Post data to api and update redux store
 * @param dispatch
 */
export const saveTemplate = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const storeState = getState();

    const {
      pages,
      defaultOptions,
      settings,
      documentId,
      templateName,
      isSaving,
      loading,
      version,
      recentColors,
      imageManifest,
      schema,
    } = storeState.templateBuilderSlice;

    // don't save if already saving or is loading
    if (loading || isSaving) {
      return;
    } else {
      dispatch(setSaving(true));
    }

    if (!environment.production) {
      console.log("SAVING", { pages, defaultOptions, settings });
    }

    // Backstop: catches any path that can drop the last reference to an image without going
    // through the fast-path removal (deleting a whole page, applying a cover design, undo, etc.)
    // so a saved document's imageManifest never carries an entry for an image no page still uses.
    const orphaned = findOrphanedManifestEntries(pages, imageManifest);
    let cleanedManifest = imageManifest;
    if (orphaned.length > 0) {
      const orphanedIds = orphaned.map((e) => e.id);
      dispatch(removeImageManifestEntries(orphanedIds));
      cleanedManifest = imageManifest.filter((e) => !orphanedIds.includes(e.id));
      await Promise.allSettled(orphaned.map((e) => deletePhoto(e.docId)));
    }

    try {
      if (environment.enabled) {
        const result = await postTemplate(templateName, {
          id: documentId,
          pages,
          defaultOptions,
          settings,
          version,
          recentColors,
          imageManifest: cleanedManifest,
          schema,
        });

        if (result) {
          dispatch(setDocumentId(result));
        }
      }
    } finally {
      dispatch(setSaving(false));
    }
  };
};
